import script from "./DataTableCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTableCell.vue?vue&type=script&setup=true&lang=ts"

import "./DataTableCell.vue?vue&type=style&index=0&id=1f839882&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f839882"]])

export default __exports__